<template>
  <div class="loginContent">
    <span class="loginBtn"
          v-show="!token"
          @click="goToLogin">登录</span>
    <div class="userName"
         v-show="token">
      <router-link :to="{name:'user'}"
                   tag="span"><img src="@/assets/index/personal.png"></router-link>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {
    token () {
      return this.$store.state.user.token
    },
    mobile () {
      return this.$store.state.userInfo.mobile
    }
  },
  mounted () {
    // let mobile = localStorage.getItem('mobile');
    // let password = localStorage.getItem('password');
    // let expire = localStorage.getItem('expire');
    // let token = sessionStorage.getItem('token');
    // let userName = sessionStorage.getItem('mobile');
    // let exp = new Date();
    // if (expire && exp.getTime() > expire) {
    //   localStorage.removeItem("mobile");
    //   localStorage.removeItem("password");
    //   localStorage.removeItem("expire");
    // } else if (expire && exp.getTime() < expire) {
    //   if (!(token && userName) && mobile && password) {
    //     this.entry({ mobile, password });
    //   }
    // }
    // this.getUserInfo()
  },
  methods: {
    //登录
    async entry (params) {
      const { mobile, password } = params
      const res = await this.$store.dispatch('user/userLogin', { tel: mobile, password })
      if (res) {
        this.getUserInfo()
      }
    },
    getUserInfo () {
      this.$store.dispatch('user/getUserInfo')
    },
    goToLogin () {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.loginContent
  height 60px
  display flex
  align-items center
  justify-content flex-end

.userName
  font-size 14px
  color #fff

.loginBtn
  font-size 12px
  padding 5px 12px
  color #34D1BC
  border-radius 15px
  border 2px solid #34D1BC
</style>
